import { SITE_DOMAIN } from '../constants/urls';

var axios = require('axios');
export class PaymentServices {
  // ** Get All Categoris
  static get() {
    var config = {
      method: 'get',
      url: `${SITE_DOMAIN}order_stripe/136`,
      headers: { 
        'Accept': 'application/json', 
        'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIzIiwianRpIjoiYzA5NzU1NzIzMDc5MWRjYzMyMzdhNTVlYzE2YzA2M2Y3N2MxZWVjOWNlNmVjYmFlNmQ5MTk1ODY5NGY0OTgxZTVjNDc3Y2UzYzYyM2VjYmUiLCJpYXQiOjE2NTg4NTQzNDYsIm5iZiI6MTY1ODg1NDM0NiwiZXhwIjoxNjkwMzkwMzQ2LCJzdWIiOiIxMDEiLCJzY29wZXMiOltdfQ.AC0s-UU7MMLtNBU0WZ_303bxW2jk0yhmAayd0QsmF-5oSGYY5LwYYFHim6Jg1BrIiVPm61r16QE9D76sjPhctOUjVeP_-Ul-fpMGjxwiac7Ir0CCYZCsoEvUX7L7-NH1RNaJ3MyTIG5x0fAYOC-2r3Bx6Enzvzfzj423odPkd1PDMCJ-NdKn3X2sdJ6fDMexzDWfZHfnFGulBotCbzH6uew7rbfHG7h5Q7PvHoiXjye_CmUYj58dhac9PfGePpOFfM6QTWRkRBLb5VMHhZ3t_je-RQLsme6hwSAHjElw3LN0IMDbiIiPnudaaUpmm5aZtwhhiWfeUI_5KcQ8xjYm0Q9mmNCa3UI1hRP6AJ-wQDSDpjNonZbReppiisiTIa0foI-XN5hY4A0fmUYVV3HBnrZsPVrBaPHeyRXbF65WBmLZRvIZbFRkMTCoRlyTYCzy3crrcuODbBzsAOH_4NmXOqi_w7x_q79Vo9uguNVQY3nqHV3INZLzKhXQGfqGAl3CS09JIWBgcZb0J1MB9M76vG5GlKd4NykxbA7ztyLVo7WehWfS0QqP-U_ami9cDHx_t7Y9UDDr8VRFs1ysDp0iGh9ao_41sGOzCFRAUgfyE6Kg0rXG3y6zd1iSOxO7YUa4-g-SjJcxvibBCZc58g8KEuXUVfMYQW8-Lo9Cvhtzr_s', 
        'Cookie': 'XSRF-TOKEN=eyJpdiI6ImVJM0tHN2R3aHZkSXA4SGc2UXhDUVE9PSIsInZhbHVlIjoiKzFyb1BIWW5sSmlVSTM5OFhIUWFBc2h5eXNEMlVSZ0R6RjIvcEswTDFYSTdnTlRlYmdGdkovRVNRT0l2V3JUMVpoSm1aTG91cmNYQ0FieTBRRkhFU210a1AwUmVHNUhITy9tZ002YUN2Wnd5aFZOZWFoWVVDaWVnOEJxQm9kajYiLCJtYWMiOiI2YWVmNGRjZDQzMjM3ZDRlNjAwMzZlZTcwYzE2YzdlZDJkMGQzMWVmN2YyZGM0YTY0ZWU3ZDJhYTg0MWY2ZGZlIn0%3D; gootech_session=eyJpdiI6IkUyZTM1MDYyM09VN3Vjd1h5bG80RkE9PSIsInZhbHVlIjoiRXAza1lBTG5mcS9xcHdoVXZabTd0U0x6dTNlWkdXNVlLTEFHZm1IeFhiNUNvMWw4dlh4QjlqL0dkYm16ODlnVlhWazdWd3g5NldYN3RUZDJCaXdqR3ZDRFdESmpidnFtUkVXYXROTGMzdDM1emJOSk1DYVV4cGNWUGdUTzNiSDgiLCJtYWMiOiI5N2MyMWMwOTg1MjA3ZDE2MTZiODM1NWU3ODA0NTQwZDg2NDNjMWVlMzI2OWUxODkyYWFlNjgzMjlmN2NmMWQ5In0%3D', 
      },
    };
    
    axios(config)
    .then(function (response) {
      console.log(JSON.stringify(response.data));
    })
    .catch(function (error) {
      console.log(error);
    });

    // return new Promise((resolve, reject) => {
    //   const list = [];
    //   for (let index = 1; index < 10; index++) {
    //     list.push({
    //       id: index,
    //       name: "أطباق فلسطينية",
    //       mainImage: require('../assets/images/images-demo/img-bg-meals.png'),
    //       image: require('../assets/images/images-demo/img-category.png')
    //     });
    //   }
    //   resolve({ data: list });
    // });
  }
}
